import { Controller } from '@hotwired/stimulus';
import { trapFocus, releaseFocusTrap } from '../utils/FocusTrap';

/**
 * Focus management for the in-page student case feedback overlay
 * (`_feedback_card_modal.html.erb`). This is not the same as `#case-completion-modal`,
 * which already uses FocusTrap from button_action_controller.
 */
export default class extends Controller {
  static targets = ['dialog'];

  connect() {
    this.section = this.element.closest('.doc-section.feedback_card');
    this.dialogEl = this.hasDialogTarget
      ? this.dialogTarget
      : this.element.querySelector('.feedback-modal[role="dialog"]');
    if (!this.dialogEl) return;

    this._trapping = false;
    this._previousFocus = null;
    this._observer = new MutationObserver(() => this.syncTrap());
    if (this.section) {
      this._observer.observe(this.section, {
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    }
    this.syncTrap();
  }

  disconnect() {
    this._observer?.disconnect();
    this._observer = null;
    this.deactivateTrap();
  }

  syncTrap() {
    if (this.shouldTrap()) {
      if (!this._trapping) {
        const active = document.activeElement;
        this._previousFocus =
          active instanceof HTMLElement && active !== document.body ? active : null;
        trapFocus(this.dialogEl);
        this._trapping = true;
      }
    } else {
      this.deactivateTrap();
    }
  }

  shouldTrap() {
    if (!this.dialogEl) return false;
    if (!this.section) return false;
    if (this.section.classList.contains('doc-section--hide-for-ai-pair')) return false;
    if (this.section.style.display === 'none') return false;
    const sectionStyle = window.getComputedStyle(this.section);
    if (sectionStyle.display === 'none' || sectionStyle.visibility === 'hidden') return false;
    const dialogStyle = window.getComputedStyle(this.dialogEl);
    if (dialogStyle.display === 'none' || dialogStyle.visibility === 'hidden') return false;
    return true;
  }

  deactivateTrap() {
    if (!this._trapping) return;
    if (this._previousFocus) {
      this.dialogEl._focusTrapPreviousElement = this._previousFocus;
    }
    releaseFocusTrap(this.dialogEl);
    this._trapping = false;
    this._previousFocus = null;
  }
}
